//@flow
import React from 'react';
import {connectionMode, appToAppScaDeviceMode} from '../../constants/ConnectionMode';
import {ConnectionModeItem} from './ConnectionModeItem';

import './ConnectionModeSelection.less';

export class ConnectionModeSelection extends React.Component {

    handleSelect = (mode) => () => {
        this.props.onSelect(mode);
    };

    render() {
        const {isAppToAppScaDevice} = this.props;
        const connectionModeToUse = isAppToAppScaDevice ? appToAppScaDeviceMode : connectionMode;

        return (
            <div>
                <div className={'connection-mode-selection-container'}>

                    {Object.keys(connectionModeToUse).map((key) => {
                        const mode = connectionModeToUse[key];
                        return (
                            <ConnectionModeItem mode={mode} key={key} onSelect={this.handleSelect(mode)} />
                        );
                    })}
                </div>
            </div>
        );
    }
}
